"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var react_dom_1 = require("react-dom");
var icons_1 = require("../../icons");
var StyledTooltip_1 = require("./StyledTooltip");
var utils_1 = require("./utils");
var Icon_1 = require("../Icon");
var TooltipInner = function (_a) {
    var content = _a.content, isOpen = _a.isOpen, targetRect = _a.targetRect, onClose = _a.onClose, id = _a.id, maxWidth = _a.maxWidth;
    var TooltipRef = react_1.default.useRef(null);
    var _b = react_1.default.useState({ top: 0, left: 0 }), location = _b[0], setLocation = _b[1];
    var _c = react_1.default.useState({ xAxis: true, yAxis: true }), isInViewport = _c[0], setIsInViewport = _c[1];
    var _d = react_1.default.useState({ height: 0, width: 0 }), tooltipRect = _d[0], setTooltipRect = _d[1];
    react_1.default.useEffect(function () {
        if (isOpen && TooltipRef.current) {
            var _a = TooltipRef.current.getBoundingClientRect(), width = _a.width, height = _a.height;
            var _b = utils_1.isDefaultTooltipsInViewport(targetRect, TooltipRef.current), xAxis = _b.xAxis, yAxis = _b.yAxis;
            setIsInViewport({ xAxis: xAxis, yAxis: yAxis });
            setTooltipRect({ width: width, height: height });
            setLocation({
                top: yAxis ? targetRect.top - height : targetRect.top + targetRect.height + 21,
                left: xAxis ? targetRect.left - width + 31 + targetRect.width / 2 : targetRect.left
            });
        }
    }, [isOpen, targetRect]);
    return react_dom_1.createPortal(react_1.default.createElement(StyledTooltip_1.StyledTooltipContainer, tslib_1.__assign({ "data-testid": "tooltip-" + (isOpen ? 'open' : 'hide'), ref: TooltipRef, isOpen: isOpen }, location, { "aria-hidden": isOpen ? 'false' : 'true', role: "tooltip", id: id, maxWidth: maxWidth }),
        react_1.default.createElement(StyledTooltip_1.StyledTooltip, null,
            react_1.default.createElement(StyledTooltip_1.StyledContentBox, null, content),
            react_1.default.createElement(StyledTooltip_1.StyledButtonWrapper, null,
                react_1.default.createElement(Icon_1.IconButton, { label: "close", onClick: onClose, "data-testid": "close-btn", iconProps: {
                        id: 'close',
                        icon: icons_1.Clear,
                        width: '12px',
                        height: '12px',
                        fill: '#0479CD'
                    } })),
            react_1.default.createElement(StyledTooltip_1.StyledArrow, { inViewport: isInViewport, tooltipHeight: tooltipRect.height, tooltipWidth: tooltipRect.width }))), document.body);
};
exports.default = TooltipInner;
//# sourceMappingURL=TooltipInner.js.map